export function getMessageOrigin(event) {
  return event.origin || event.originalEvent.origin;
}

export function isSubmitCallback(messageName) {
  return typeof messageName === 'string' && messageName.startsWith('submitCallback');
}
